export const PAID_PLANS = ['starter', 'pro', 'institutional'];

export const PLAN_LABELS = {
  starter: 'Base',
  pro: 'Pro',
  institutional: 'Institutional',
  free: 'Free',
};

export function normalizePlan(plan) {
  if (!plan) return 'free';
  const p = String(plan).toLowerCase();
  return p === 'oneyear' ? 'starter' : p;
}

export function isPaidPlan(plan, status = 'active') {
  const normalized = normalizePlan(plan);
  return PAID_PLANS.includes(normalized) && status === 'active';
}

export function planLabel(plan) {
  return PLAN_LABELS[normalizePlan(plan)] || normalizePlan(plan);
}
